import styled from "@emotion/styled";

export const ReviewRoot = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 24px 24px 56px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @media (max-width: 1023px) {
        padding: 24px 16px 56px;
    }
`;

export const ReviewHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 0 8px 24px;
    text-align: center;
    width: 100%;
    max-width: 600px;

    @media (max-width: 1023px) {
        max-width: 100%;
    }
`;

export const ReviewTitle = styled.p`
    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: #e9ecf5;
    white-space: nowrap;
`;

export const ReviewSubtitle = styled.p`
    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #b7bdcb;
    white-space: nowrap;
`;

export const ReviewCard = styled.div`
    width: 100%;
    max-width: 600px;
    background: #1e1f22;
    border: 1px solid #2b2d33;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow: hidden;

    @media (max-width: 1023px) {
        max-width: 100%;
    }
`;

export const ReviewRow = styled.div<{ $unanswered?: boolean }>`
    background: ${(p) => (p.$unanswered ? "rgba(94, 132, 237, 0.06)" : "#1e1f22")};
    border-radius: 12px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow: hidden;
`;

export const ReviewRowHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const QuestionNumber = styled.p`
    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 150%;
    color: #e9ecf5;
    text-align: center;
    white-space: nowrap;
`;

export const StateTag = styled.div<{ $unanswered?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 999px;
    overflow: hidden;
    background: ${(p) =>
        p.$unanswered ? "rgba(94, 132, 237, 0.24)" : "rgba(94, 132, 237, 0.15)"};
`;

export const StateTagText = styled.span`
    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
    color: #8fb0ff;
    text-align: center;
    white-space: nowrap;
`;

export const ResponsePreview = styled.p`
    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #b7bdcb;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const AddResponseRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 8px;
    width: 100%;
`;

export const AddResponseLink = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #5e84ed;
    text-align: center;
    white-space: nowrap;

    &:hover {
        opacity: 0.85;
    }
`;

export const ReviewDivider = styled.div`
    width: 100%;
    height: 1px;
    background: #2b2d33;
`;

export const ReviewSpacer = styled.div`
    flex: 1;
    min-height: 24px;
`;

export const SubmitWrap = styled.div`
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;

    @media (max-width: 1023px) {
        max-width: 100%;
    }
`;

export const SubmitBtn = styled.button`
    width: 343px;
    height: 40px;
    min-width: 120px;

    border-radius: 12px;
    border: 1px solid #5e84ed;
    background: #5e84ed;

    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    color: #ffffff;
    cursor: pointer;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &:active:not(:disabled) {
        background: #2457e3;
        transform: translateY(1px);
    }

    @media (max-width: 1023px) {
        width: 100%;
    }
`;
